import React from 'react'
import { ICON_SIZE } from '../Icon/constants'
import { STATUS_TAGS_ICON } from './constants'
import { Chip, ChipLabel } from './styles'
import type { StatusTagProps } from './types'

const StatusTag: React.FC<StatusTagProps> = ({ label, icon, variant, onClick, testId, isIconFilled }) => {
  const variantIcon = variant && STATUS_TAGS_ICON[variant]
  const IconComponent = icon ?? variantIcon?.icon
  const isFilled = isIconFilled ?? variantIcon?.isFilled

  return (
    <Chip
      icon={IconComponent && <IconComponent size={ICON_SIZE.small} isFilled={isFilled} />}
      label={<ChipLabel variant="body2">{label}</ChipLabel>}
      variant="outlined"
      size="small"
      data-testid={testId}
      onClick={onClick}
      disableRipple
    />
  )
}

export default StatusTag
